module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dash-footer"
    }
  }, [_c('footer', {
    staticClass: "main-footer"
  }, [_c('div', {
    staticClass: "pull-right hidden-xs"
  }, [_c('b', [_vm._v("ESS-ONLINE Version")]), _vm._v(_vm._s(_vm.version) + "\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" Bangkok Thailand (1988)\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_vm._v("\n      Copyright © "), _c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": require("assets/img/pps_logo.png")
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "text-skin",
    attrs: {
      "href": "http://peopleplus.co.th",
      "target": "_blank"
    }
  }, [_vm._v("People Plus Software Co.,Ltd.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9e5fc4ba!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dash/DashFooter.vue
// module id = 3940
// module chunks = 1